import React, { memo } from "react"
import { CategoricalNode as CategoricalNodeType } from "@features/builder/graph/types"
import NodeContainer from "@features/builder/graph/nodes/NodeContainer"

export const CategoricalNode = memo((node: CategoricalNodeType) => {
  return (
    <NodeContainer node={node}>
      <div className="graph-node-container">
        <div className="graph-node-type graph-node-categorical">{node.type}</div>
        <div className="graph-node-label">{node.data.label}</div>
      </div>
    </NodeContainer>
  )
})

CategoricalNode.displayName = "CategoricalNode"
